const AuthLogo = ({ inline = false }) => (
  <div
    className={
      inline
        ? "mb-6 flex justify-start"
        : "absolute top-0 left-0 right-0 z-10 flex justify-center pb-2 pt-[88px] sm:left-10 sm:right-auto sm:justify-start sm:pb-0 xl:left-20"
    }
  >
    <div className="rounded-full bg-white p-3 shadow-md">
      <img src="/logo2.png" alt="Logo" className="h-9 w-auto object-contain" />
    </div>
  </div>
);

export default AuthLogo;